module.exports = __webpack_public_path__ + "static/media/image_1_hover.0b156d1d.png";